import { apiProxyRequest } from "Api/apiProxyRequest";

import type { TwoFactorAuthentication } from "./types";

export const getTFARequest = (userId: string) =>
  apiProxyRequest<TwoFactorAuthentication>(`/users/${userId}/totp`);
